import { Action, createReducer, on } from '@ngrx/store';
import { listToDictionary } from '@symphony-solo/shared/utils/src';
import { LoadTaxratesAction, LoadTaxratesErrorAction, LoadTaxratesSuccessAction } from './taxrate.actions';
import { TaxrateState } from './taxrate.state';

const initialState = new TaxrateState();

const reducer = createReducer(
  initialState,
  on(LoadTaxratesAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(LoadTaxratesSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.taxrates = listToDictionary(payload.taxrates, 'id');
    return newState;
  }),
  on(LoadTaxratesErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function taxratesReducer(state: TaxrateState | null, action: Action) {
  return reducer(state, action);
}
